(function() {
    'use strict';

    angular
        .module('bhsApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
